import React from 'react'
import { toDate } from '@ztechapps/common.utils'
import { useInvoiceListContext } from '../Context'
import { DateTimeInput } from '@ztechapps/webui.date'

export const PeriodPickerCell = ({ props, month, year, selectedDate, isValid }) => {
  const monthStr = String(month + 1).padStart(2, '0')
  const date = toDate(`${year}-${monthStr}-01`)
  const formattedMonth = date.format('MMM')
  const validDate = isValid({ date: date.format('YYYY-MM-01') })

  if (validDate || date.format('YYYY-MM-01') === selectedDate.format('YYYY-MM-01')) {
    return <td {...props}>{formattedMonth}</td>
  } else {
    return (
      <td style={{ borderColor: 'white', color: 'white', backgroundColor: '#696969' }} {...props} title={'Old period'}>
        {formattedMonth}
      </td>
    )
  }
}

export const IssuePeriodPicker = () => {
  const context = useInvoiceListContext()
  const [issueDateYearMonthFilter, setIssueDateYearMonthFilter] = context.invoiceFilters.issueDateYearMonthFilter

  const onChange = (value: any) => {
    setIssueDateYearMonthFilter(value)
  }

  return <DateTimeInput onChange={onChange} value={issueDateYearMonthFilter} type="month" />
}
